export default __webpack_public_path__ + "static/media/R90.c84d735c.png";